import Row from 'framework-data-table/table/components/Row';
import { useListingLibBulkActions } from 'framework-listing-lib/internal/Table/providers/ListingLibBulkActionsProvider';
import ListingLibRowComponent from 'framework-listing-lib/internal/FrameworkDataTable/components/ListingLibRowComponent';
import ListingLibEmptyCell from 'framework-listing-lib/table/ListingLibEmptyCell';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibTableRow(props) {
  const {
    crmObject,
    disableBulkSelect = false
  } = props;
  const {
    hasBulkActions
  } = useListingLibBulkActions();
  const rowHasBulkActions = !disableBulkSelect && hasBulkActions;
  const columns = [...(props.columns || [])];
  if (disableBulkSelect && hasBulkActions) {
    columns.unshift({
      CellComponent: ListingLibEmptyCell,
      HeaderContentComponent: ListingLibEmptyCell,
      columnName: 'empty-column',
      columnNamespace: 'empty-column',
      width: 0,
      minimumColumnWidth: 0,
      reorderable: false,
      sortable: false,
      resizable: false
    });
  }
  return /*#__PURE__*/_jsx(Row, {
    columns: columns,
    row: crmObject,
    RowComponent: ListingLibRowComponent,
    rowId: `${crmObject.objectId}`,
    rowIndex: -1,
    selectable: rowHasBulkActions
  });
}